// extracted by mini-css-extract-plugin
module.exports =  {"img":"_93444fe79c--img--_7hry","footer":"_93444fe79c--footer--o2LMh"};